import * as Toast from '@radix-ui/react-toast'
import React, { useEffect } from 'react'
import { tv } from 'tailwind-variants'
import Button from './Button'

import { Close, Info, OfflinePin, Warning } from '~/icons'

export interface ToastProps {
  content: string
  altText?: string
  status?: 'success' | 'error' | 'info'
  isOpen?: boolean
  onOpenChange?: React.Dispatch<any>
  hasButton?: boolean
  buttonAction?: () => void
}

const toastVariants = tv({
  base: 'w-80 flex gap-2 p-2 pl-4 text-white bg-gray-100 rounded-md items-top self-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=cancel]:translate-y-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut',
  variants: {
    status: {
      success: 'bg-primary-success',
      error: 'bg-primary-error',
      info: 'bg-primary-info',
    },
  },
})

const iconsChange = {
  success: <OfflinePin className="text-xl fill-white" />,
  error: <Warning className="text-xl fill-white" />,
  info: <Info className="text-xl fill-white" />,
}

export default function ToastComponent({
  content,
  altText,
  status,
  isOpen,
  onOpenChange,
  hasButton,
  buttonAction,
}: ToastProps) {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onOpenChange?.(false)
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [isOpen, onOpenChange])

  const handleClose = () => {
    onOpenChange?.(false)
  }

  return (
    <Toast.Root className={toastVariants({ status })} open={isOpen} onOpenChange={onOpenChange}>
      {status && iconsChange[status]}
      <div className="flex flex-col">
        <Toast.Description className="w-full max-w-80">{content}</Toast.Description>
        {hasButton && (
          <Toast.Action altText={altText || content} asChild>
            <Button
              className="flex self-center border-white w-fit min-w-20 justify-center"
              size="sm"
              isOutlined
              onPress={buttonAction}
            >
              {altText}
            </Button>
          </Toast.Action>
        )}
      </div>
      <div className="border-l px-3 content-center border-white flex">
        <Toast.Close aria-label="Close" asChild>
          <button type="button" onClick={handleClose}>
            <Close className="fill-white cursor-pointer" />
          </button>
        </Toast.Close>
      </div>
    </Toast.Root>
  )
}
